module.exports = __webpack_public_path__ + "static/media/flag-mk.dce090a0.webp";